<template>
  <div>
    <router-link to="/" class="link">&#60;&#60; back</router-link>
    <h2 class="title">{{ editMode ? 'Edit' : 'New' }} Phrase</h2>
    <input class="input"
            type="text"
            name="label"
            id="label"
            ref="label"
            v-model="label"
            placeholder="Label (optional)">
    <textarea class="input"
              name="text"
              id="text"
              ref="text"
              v-model="text"
              rows="4"
              placeholder="Phrase"></textarea>
    <button type="button"
            class="formButton"
            style="float: right;"
            @click="savePhrase()">Save</button>
    <button type="button"
            class="formButton"
            :class="{ 'formButton--active': ttsActive === 'test' }"
            @click="doSpeech(text, 'test')">Test</button>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import speech from '@/mixins/speech';

export default {
  name: 'Manage',
  mixins: [speech],
  data() {
    return {
      label: '',
      text: '',
      exists: false,
    };
  },
  computed: {
    ...mapState(['phrases', 'editMode']),
  },
  methods: {
    savePhrase() {
      // Only do anything if text isn't blank
      if (this.text) {
        // Call specific function depending on whether we're editing or creating
        if (this.exists) {
          this.editPhrase({
            label: this.label,
            text: this.text,
            id: this.$route.params.id,
          });
        } else {
          this.addPhrase({
            label: this.label,
            text: this.text,
          });
        }
        // Navigate back to the phrases list
        this.$router.push({ path: '/' });
      }
    },
    ...mapActions(['addPhrase', 'editPhrase', 'toggleEditMode']),
  },
  mounted() {
    // If we're editing instead of creating, lets disable edit mode once we're in
    if (this.exists) {
      this.toggleEditMode();
    }
  },
  created() {
    // We're gonna check whether the key that's been provided exists
    // and if so populate the form with the existing phrase
    // We can't just look at the provided ID as 0 equates to false...
    this.exists = this.$route.params.id !== 'undefined' && this.$route.params.id < this.phrases.length;
    if (this.exists) {
      this.text = this.phrases[this.$route.params.id].text;
      // If the label and the text match, blank out the label
      // We storing both the label and text in the store even if they match so that we can sort them
      // But if they match then you only need to edit the text parameter
      this.label = (this.text === this.phrases[this.$route.params.id].label) ? '' : this.phrases[this.$route.params.id].label;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/mixins.scss';
.link {
  margin-bottom: 1rem;
}
</style>
